import { TransferenceType } from '@autofact-lib/operation-lib-model-notary-platform';

const TransferenceTypeService = {
  codeToString(typeCode){
    const type = Object.values(TransferenceType).find(elementType => elementType.id === typeCode);
    if (!type) {
      return null;
    }

    return type.shortLabel;
  }
};

export default TransferenceTypeService;
